import { useRef } from 'react';
import { FormInstance } from 'antd';
import { CapturedIdDocument, IdDocumentNames } from 'features/eiq-secure/heplers/id-document.helper';

interface IdDocumentHandle {
  getIdDocument: () => CapturedIdDocument | null | undefined;
}

interface IUseIdDocumentOptions {
  form: FormInstance;
  shouldUseDriverName?: () => boolean;
  onNamesChanged?: () => void;
  onClear?: () => void;
}

export const useIdDocument = ({ form, shouldUseDriverName, onNamesChanged, onClear }: IUseIdDocumentOptions) => {
  const idDocumentRef = useRef<IdDocumentHandle | null>(null);

  const updateFromIdDocument = (firstName?: string | null, lastName?: string | null) => {
    const isDriver = shouldUseDriverName?.() ?? false;
    form.setFieldValue(isDriver ? 'driverFirstName' : 'firstName', firstName);
    form.setFieldValue(isDriver ? 'driverLastName' : 'lastName', lastName);
    onNamesChanged?.();
  };

  const onIdDocumentRecognized = (document?: IdDocumentNames | null) => {
    if (document) {
      updateFromIdDocument(document.firstName, document.lastName);
    }
  };

  const onUpdateFromCameraClicked = () => {
    updateFromIdDocument('', '');
    onClear?.();
  };

  return { idDocumentRef, updateFromIdDocument, onIdDocumentRecognized, onUpdateFromCameraClicked };
};
